import { ComplianceProgramNotificationPreference } from "../../../types/graphql-schema";

export const getProgramNotificationSettings = (
  hasSlackConnection: boolean,
  hasTeamsNotificationConnection: boolean,
) => [
  ...(hasSlackConnection
    ? [
        {
          name: "Slack only",
          value: ComplianceProgramNotificationPreference.Slack,
          info: "If Slack is unavailable, Email will be used as a fallback.",
        },
      ]
    : []),
  ...(hasTeamsNotificationConnection
    ? [
        {
          name: "Microsoft Teams only",
          value: ComplianceProgramNotificationPreference.Teams,
          info: "If Microsoft Teams is unavailable, Email will be used as a fallback.",
        },
      ]
    : []),
  {
    name: "Email only",
    value: ComplianceProgramNotificationPreference.Email,
  },
];

export const getEffectiveNotificationPreference = (
  preference: ComplianceProgramNotificationPreference | null | undefined,
  settings: ReturnType<typeof getProgramNotificationSettings>,
) =>
  preference && settings.some((setting) => setting.value === preference)
    ? preference
    : ComplianceProgramNotificationPreference.Email;
